import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import Cookies from "js-cookie";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Swal from "sweetalert2";

const IoArrowBack = require("react-icons/io5").IoArrowBack;

const EntryLhkpn = () => {
  const { id } = useParams<{ id: string }>();
  const token = Cookies.get("token");

  const [loading, setLoading] = useState(true);
  const [presiden, setPresiden] = useState<any>(null);
  const [lhkpn, setLhkpn] = useState("");
  const [nama, setNama] = useState("");

  // ✅ function fetchPresiden bisa dipanggil ulang
  const fetchPresiden = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/presiden/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = res.data;
      setPresiden(data);
      setLhkpn(data.lhkpn || "");
      setNama(data.nama || "");
    } catch (err) {
      console.error("Gagal fetch detail:", err);
      Swal.fire("Error", "Gagal memuat data presiden.", "error");
    } finally {
      setLoading(false);
    }
  };

  // auto scroll + fetch data
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    fetchPresiden();
  }, [id, token]);

  // handle update biografi
  const handleUpdate = async (e: React.FormEvent) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("lhkpn", lhkpn);
    formData.append("_method", "PUT");

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/presiden/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // ✅ Popup sukses
      Swal.fire({
        title: "Berhasil!",
        text: "LHKPN berhasil diperbarui.",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        // ⬇️ fetch ulang data setelah klik OK
        fetchPresiden();
      });
    } catch (err) {
      console.error("Gagal update:", err);
      Swal.fire("Error", "Gagal memperbarui LHKPN.", "error");
    }
  };

  if (loading)
    return (
      <div className="flex justify-center items-center h-40">
        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-primary"></div>
      </div>
    );
  if (!presiden) return <p>Data tidak ditemukan.</p>;

  return (
    <div className="mt-6 max-w-2xl mx-auto border rounded-sm shadow-sm p-4">
      <Link to={`/dashboard/presiden-detail/${id}`}>
        <div className="flex items-center gap-3 mb-4">
          <IoArrowBack />
          <h1 className="text-xl font-medium">
            Detail LHKPN <span className="font-bold">{nama}</span>
          </h1>
        </div>
      </Link>

      <form onSubmit={handleUpdate} className="space-y-4">
        <div>
          <label className="block font-semibold mb-2">LHKPN</label>
          <ReactQuill value={lhkpn} onChange={setLhkpn} theme="snow" style={{ height: "200px", overflowY: "auto" }} />
        </div>

        <div className="flex justify-end mt-7">
          <button type="submit" className="bg-primary text-white px-4 py-2 rounded">
            Simpan Perubahan
          </button>
        </div>
      </form>
    </div>
  );
};

export default EntryLhkpn;
